<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.055 35.669">
    <g id="Gruppe_3529" data-name="Gruppe 3529" transform="translate(-18393.026 -13324.5)">
      <path :fill="fillColor" id="Pfad_6177" data-name="Pfad 6177" d="M1331.651,20.209s.512-.619.747-.937c3.555-4.722,4.435-10.32,1.749-14.306-3.716-5.509-12.849-5.846-20.4-.753a22.018,22.018,0,0,0-3.966,3.411,23.5,23.5,0,0,1,4.278-3.7c9.141-6.166,20.75-4.939,25.93,2.741a15.181,15.181,0,0,1,2.185,11.405c-.033.184-.11.553-.11.553Z" transform="translate(17088.615 13324.5)"/>
      <path :fill="logoColor1" id="Pfad_6178" data-name="Pfad 6178" d="M1266.25,28.8c-3.715-5.51-.606-14.1,6.943-19.2s16.684-4.756,20.4.753a9.042,9.042,0,0,1,.784,1.43c-3.346-4.715-11.711-4.69-18.8.095-7.166,4.831-10.316,12.689-7.037,17.547,1.771,2.629,5.063,3.842,8.844,3.637-4.659.505-8.884-.935-11.13-4.265" transform="translate(17129.17 13319.115)"/>
      <path :fill="logoColor2" id="Pfad_6179" data-name="Pfad 6179" d="M1275.921,101.409l17.7-2.4-6.894,13.961-2.157-2.321c-.4.269-.47.3-.874.541-8.933,5.29-19.775,3.848-24.731-3.5-4-5.935-2.995-13.984,1.882-20.18-3.732,4.779-4.706,10.524-1.964,14.59,3.346,4.96,11.084,5.729,18.1,2.115.343-.176,1.025-.56,1.025-.56Z" transform="translate(17136.539 13245.805)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'MainLogo',
  computed: {
    logoColor1() {
      return '#FFD400'
    },
    logoColor2() {
      return '#D9000D'
    },
  },
  props: {
    fillColor: {
      type: String,
    }
  }
}
</script>

<style scoped>

</style>
